import { Box } from '@mui/material'
import React from 'react'
import StudentRegistration from './StudentRegistration'
import SubscribeSection from './SubscribeSection'
import CustomDivider from '../../shared/utils/CustomDivider'
import KnowMoreSection from './KnowMoreSection'
import LatestCourses from './LatestCourses'
import HeroSection from './HeroSection'
import LatestEvent from './LatestEvent'
import TestimonialSection from './TestimonialSection'
import { Page_Padding } from '../../shared/constants'


const Home = () => {
  return (
    <Box className="body home" px={Page_Padding}>
       <HeroSection />
      <CustomDivider orientation='horizontal' />
      {/* <AddSection/>
      <CustomDivider orientation='horizontal' /> */}
       {/* <ExploreServices /> */}
      {/* <CustomDivider orientation='horizontal' />
      <ExploreCourses />
      <CustomDivider orientation='horizontal' />  */}
      <LatestCourses />
      <CustomDivider orientation='horizontal' />
      <LatestEvent/>
      <CustomDivider orientation='horizontal' />

      <KnowMoreSection />
  
      <CustomDivider orientation='horizontal' />
      
      <SubscribeSection />
      <CustomDivider orientation='horizontal' />
      {/* <CustomDivider orientation='horizontal' /> */}
      <StudentRegistration />
      <CustomDivider orientation='horizontal' />
      {/* <CustomDivider orientation='horizontal' />
      <CustomDivider orientation='horizontal' /> */}
      <TestimonialSection/>
      
    </Box>
  )
}

export default Home